import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import useTranslatedRoutes from '../../services/translatedRoutes'
import TrustElementsHeader from '../TrustElementsHeader'

export default function PluginSearchTitle () {
  const { t } = useTranslation(['plugins', 'categories', 'applications'])
  const router = useRouter()
  const language = router.locale.toUpperCase()
  const { getSoftwareName, getCategoryName } = useTranslatedRoutes(language)
  const title = useMemo(() => {
    const { category, application, search } = router.query

    if (!category && !application && !search) {
      return t('title')
    }
    if (search && !application && !category) {
      return t('searchprefix', { term: search })
    }
    if (application) {
      return t('searchprefix', { term: t(getSoftwareName(application), { ns: 'applications' }) })
    }
    if (category) {
      return t('searchprefix', { term: t(getCategoryName(decodeURI(category)), { ns: 'categories' }) })
    }
  }, [router.query, t, getSoftwareName, getCategoryName])

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <TrustElementsHeader
            elements={t('trust_elements.elements', { returnObjects: true })}
            title={title}
          />
        </div>
      </div>
    </div>
  )
}
